import AjdustLinkGenerator from './Home.adjust-link-generator.vue'
export default AjdustLinkGenerator